import React from 'react';

interface Props {
  children: React.ReactNode;
  /** Wechselt der Wert, wird der Fehlerzustand zurückgesetzt (z.B. bei Routenwechsel). */
  resetKey?: string | number;
}

interface State {
  error: Error | null;
}

/**
 * Fängt Render-Fehler einzelner Seiten ab und zeigt die Meldung inline an,
 * statt die ganze App weiß werden zu lassen. Beim Routenwechsel (resetKey)
 * wird der Fehlerzustand zurückgesetzt, damit andere Seiten wieder laden.
 */
export class ErrorBoundary extends React.Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidUpdate(prev: Props) {
    if (prev.resetKey !== this.props.resetKey && this.state.error) {
      this.setState({ error: null });
    }
  }

  override render() {
    if (this.state.error) {
      return (
        <div className="mx-auto max-w-2xl space-y-3 p-6">
          <h2 className="text-lg font-semibold text-danger">
            Diese Seite konnte nicht geladen werden
          </h2>
          <p className="text-sm text-muted-foreground">
            Ein Fehler ist beim Anzeigen aufgetreten. Details:
          </p>
          <pre className="whitespace-pre-wrap rounded-md bg-muted/50 p-4 text-xs text-foreground">
            {this.state.error.message}
            {'\n\n'}
            {this.state.error.stack}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}
